import React from 'react';

import ScaledImage from '../app/ScaledImage';
import styles from './bankListRow.module.scss';
import { Link } from 'react-router-dom';

interface IProps {
  onClick?: () => void;
  className?: string;
  label: string;
  logoUrl?: string;
  to: string;
  altText?: string;
}

function getClassNameByLength(str: string) {
  return str.length > 35 ? styles.longText : undefined;
}

const BankListRow: React.FC<IProps> = (props: IProps) => {
  const { label, onClick, logoUrl, to, altText } = props;

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`${styles.row} ${props.className} border-2 border-gray-200 hover:border-primary-2 max-h-14 mb-2`}
      data-testid="bank-list-row"
    >
      <span className={getClassNameByLength(label)} data-testid="bank_name_matched_results">
        {label}
      </span>
      <div aria-hidden="true" className={styles.imageWrapper}>
        <ScaledImage alt={altText ?? label} url={logoUrl} scaleWidth={64} scaleHeight={48} />
      </div>
    </Link>
  );
};

export default BankListRow;
